import { Chip } from '@mui/material';
import { getCurrentSchoolYear } from '../lib/tables';

export default function SchoolYearBadge({ year, sx }) {
  if (!year || year === 'all') {
    return (
      <Chip
        size="small"
        label="Toți anii"
        sx={{ bgcolor: '#000000', color: '#ffffff', fontWeight: 600, ...sx }}
      />
    );
  }

  const isCurrent = year === getCurrentSchoolYear();

  return (
    <Chip
      size="small"
      label={isCurrent ? `An ${year} (curent)` : `An ${year} (anterior)`}
      sx={{
        bgcolor: isCurrent ? '#000000' : '#ffffff',
        color: isCurrent ? '#ffffff' : '#000000',
        border: '1px solid #000000',
        fontWeight: 600,
        ...sx,
      }}
    />
  );
}
